export const matchEmbeddedAndModal = (pathname: string, locale: string) => {
  if (new RegExp(`^(/${locale})?/embedded/modal/`).test(pathname)) {
    return '/embedded/modal';
  } else if (new RegExp(`^(/${locale})?/embedded/`).test(pathname)) {
    return '/embedded';
  }
  return '';
};

export const stripBaseURL = (pathname: string, locale: string) =>
  pathname.replace(
    new RegExp(`^(/${locale})?${matchEmbeddedAndModal(pathname, locale)}(/.*)?$`),
    '$2'
  );
